<template>
  <b-container>
    <Header
      v-if="listExist('featured_styles')"
      :items="list('featured_styles')"
      :show-story-image="true"
      type="style"
    >
      {{ $t('main.groupers.styles.header') }}
    </Header>
    <div class="title text-center mt-5">
      <h2 class="grouper-subtitle">{{ $t('main.groupers.styles.text3') }}</h2>
    </div>
    <div class="w-100">
      <Grid :group="styles" :type="getStylesName" />

      <div
        v-if="!enough"
        v-infinite-scroll="getData"
        infinite-scroll-disabled="loadingNiche"
        class="d-flex w-100 justify-content-center align-items-cente"
      >
        <Loading />
      </div>
    </div>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Header from '@/components/Groupers/PageHeader';
import Grid from '@/components/Groupers/Grid';
import Loading from 'UI/Loading';
export default {
  nuxtI18n: {
    paths: {
      en: '/styles',
      de: '/stilarten',
      es: '/estilos',
      pt: '/estilo'
    }
  },
  components: {
    Header,
    Grid,
    Loading
  },
  data() {
    return {
      enough: false,
      addItems: false
    };
  },
  async fetch({ store }) {
    await Promise.all([
      store.dispatch('styles/LOAD_STYLES'),
      store.dispatch('listings/GET_LIST', { name: 'featured_styles', type: 'style' })
    ]);
  },
  head() {
    const i18nSeo = this.$seoPlugin({ slash: true });
    return {
      link: [...i18nSeo.link]
    };
  },
  computed: {
    ...mapGetters('styles', ['getStylesName']),
    ...mapGetters('listings', ['list', 'listExist']),
    ...mapState('styles', ['styles', 'loadingStyle', 'stylesTotalPages', 'stylesCurrentPage'])
  },
  methods: {
    async getData() {
      if (this.stylesCurrentPage < this.stylesTotalPages && !this.loadingStyle) {
        this.addItems = true;
        await this.$store.dispatch('styles/LOAD_STYLES', { page: this.stylesCurrentPage + 1 });
        this.stylesCurrentPage === this.stylesTotalPages && (this.enough = true);
      } else if (this.stylesCurrentPage === this.stylesTotalPages) this.enough = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 1.8em;
}
.grouper-subtitle {
  width: 100%;
  min-height: 100%;
  height: auto;
  padding: 0;
  font-weight: 400;
  line-height: 1.5;
  font-size: 28.8px;
}
</style>
